import dayjs from 'dayjs'
import { NavigationItem, NavigationItemType } from 'components/charts/granularity-navigation/types.ts'
import { PreviousBillingCyclePeriod } from 'types/billShock.ts'
import { ProductType } from 'types/types.ts'
import { HANDLED_CONSUMPTION_TRANSFO_ERRORS } from './constants.ts'

/**
 * Generates the previous billing cycles navigation items based on the given previousBillingCyclesPeriods & activeProductType
 *
 * @param {PreviousBillingCyclePeriod[]} previousBillingCyclesPeriods
 * @param {ProductType} activeProductType
 * @returns {{ [key: string]: NavigationItem }}
 */
export const generatePreviousBillingCycleNavigationItems = (
  activeProductType: ProductType,
  previousBillingCyclesPeriods?: PreviousBillingCyclePeriod[]
): { [key: string]: NavigationItem } => {
  return (
    previousBillingCyclesPeriods?.reduce(
      (
        prev: {
          [key: string]: NavigationItem
        },
        curr: PreviousBillingCyclePeriod
      ) => {
        if (
          (activeProductType === ProductType.ELECTRICITY && curr.fuel?.electricity) ||
          (activeProductType === ProductType.GAS && curr.fuel?.gas)
        )
          prev[curr.id] = {
            type: NavigationItemType.CYCLE,
            text: `${dayjs(curr.startDate).format('DD/MM/YY')} - ${dayjs(curr.endDate).format('DD/MM/YYYY')}`,
            id: curr.id,
            fuel: curr.fuel
          } as NavigationItem
        return prev
      },
      {}
    ) || {}
  )
}

/**
 * Type-guard for the handled Transfo errors displayed on the consumption section
 * @param {string} errorCode
 * @returns {errorCode is (typeof HANDLED_CONSUMPTION_TRANSFO_ERRORS)[number]}
 */
export const isHandledConsumptionTransfoError = (errorCode?: string): errorCode is (typeof HANDLED_CONSUMPTION_TRANSFO_ERRORS)[number] => {
  if (!errorCode || typeof errorCode !== 'string') return false
  return HANDLED_CONSUMPTION_TRANSFO_ERRORS.some((code) => code === errorCode)
}
